import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { getProductionOrderList } from "../../../../services/production/productionService";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";

function ProductionOrderList({ history }) {
  const [productionOrders, setProductionOrders] = useState([]);
  const getProductionOrders = async () => {
    const response = await getProductionOrderList();
    const { data } = response.data;
    setProductionOrders(data.productionOrders);
  };
  useEffect(() => {
    getProductionOrders();
  }, []);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Production Order List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/production/production-order",
            title: "Production Order List",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
          {
            title: "New Production Order",
            color: "primary",
            icon: "fas fa-plus-circle",
            onClick: () => {
              history.push("/production/production-order-form");
            },
          },
        ]}
      />
      <ContentLayout>
        <CustomDataTable
          data={productionOrders}
          //dataDetailColumns={warehouseDetailColumn}
          onRefreshData={() => {
            //this.getWarehousesData();
          }}
          columns={[
            {
              header: "ID",
              field: "ID",
              sortable: true,
              filter: true,
            },
            {
              header: "Plant",
              field: "plantName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.plantName} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
            },
            {
              header: "Item",
              field: "itemName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
            },
            {
              header: "Qty",
              field: "prodQty",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.prodQty} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
            },
            {
              header: "Uom",
              field: "uomName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.uomName} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
            },
            {
              header: "Actions",
              body: (rowData) => (
                <React.Fragment>
                  <BootstrapTooltip title="Process Production Order">
                    <button
                      type="button"
                      onClick={(event) => {
                        history.push(
                          `/production/process-production-order-form/${rowData.ID}`
                        );
                      }}
                      className="btn btn-icon btn-label-warning btn-circle btn-md mx-1"
                    >
                      <i className="fas fa-cogs"></i>
                    </button>
                  </BootstrapTooltip>
                  <BootstrapTooltip title="Edit Plant">
                    <button
                      type="button"
                      onClick={(event) => {}}
                      className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                  </BootstrapTooltip>
                  <BootstrapTooltip title="Delete Plant">
                    <button
                      type="button"
                      onClick={(event) => {}}
                      className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </BootstrapTooltip>
                </React.Fragment>
              ),
              sortable: false,
            },
          ]}
        />
      </ContentLayout>
    </React.Fragment>
  );
}

export default ProductionOrderList;
